import { createIcon } from '@chakra-ui/icons';

export const AuthoringGrayFile = createIcon({
  displayName: 'AuthoringGrayFile',
  viewBox: '0 0 44 44',
  path: [
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4799_22657)">
        <path
          d="M1.15576 22.8914C1.15576 39.3223 18.9427 49.5917 33.1724 41.3762C39.7764 37.5633 43.8446 30.517 43.8446 22.8914C43.8446 6.46046 26.0576 -3.8089 11.828 4.40661C5.22396 8.21941 1.15576 15.2658 1.15576 22.8914Z"
          fill="#F6F6F6"
        />
        <path
          d="M13.1704 34.8365C13.1701 35.1847 13.4525 35.4671 13.8007 35.4668H32.0737C32.4217 35.4668 32.7037 35.1845 32.7034 34.8365V14.3561L27.3474 9H13.7991C13.4517 9.00088 13.1704 9.2828 13.1704 9.63025V34.8365Z"
          fill="white"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2915 20.7783H22.1745V26.6613H16.2915V20.7783Z"
          fill="#D4D4D4"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.939 25.7793C23.9361 28.2701 26.6307 29.8299 28.7892 28.5869C29.7933 28.0088 30.4116 26.9379 30.4102 25.7793C30.4131 23.2885 27.7185 21.7287 25.56 22.9717C24.5559 23.5498 23.9376 24.6207 23.939 25.7793Z"
          fill="#D4D4D4"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1704 34.8365C13.1701 35.1847 13.4525 35.4671 13.8007 35.4668H32.0737C32.4217 35.4668 32.7037 35.1845 32.7034 34.8365V14.3561L27.3474 9H13.7991C13.4517 9.00088 13.1704 9.2828 13.1704 9.63025V34.8365Z"
          stroke="#535353"
          strokeWidth="0.421821"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.7037 14.3561H27.936C27.611 14.3561 27.3477 14.0927 27.3477 13.7678V9L32.7037 14.3561Z"
          fill="#D4D4D4"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7715 39.7031C15.7715 40.4117 21.3966 40.8546 25.8967 40.5003C27.9853 40.3358 29.2719 40.0319 29.2719 39.7031C29.2719 38.9945 23.6467 38.5516 19.1466 38.906C17.0581 39.0704 15.7715 39.3743 15.7715 39.7031Z"
          fill="#C7C7C7"
        />
        <path
          d="M25.591 18.8094C25.5811 18.616 25.3654 18.5058 25.2028 18.6111C25.2026 18.6112 25.203 18.611 25.2028 18.6111L20.6575 21.5627C20.495 21.6683 20.5078 21.9101 20.6805 21.998L25.5087 24.4586C25.6815 24.5461 25.8843 24.4142 25.8744 24.2208L25.591 18.8094Z"
          fill="#D4D4D4"
        />
        <path
          d="M25.2028 18.6111C25.3654 18.5058 25.5811 18.616 25.591 18.8094L25.8744 24.2208C25.8843 24.4142 25.6815 24.5461 25.5087 24.4586L20.6805 21.998C20.5078 21.9101 20.495 21.6683 20.6575 21.5627L25.2028 18.6111ZM25.2028 18.6111C25.2026 18.6112 25.203 18.611 25.2028 18.6111Z"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4799_22657">
          <rect width="44" height="44" fill="white" transform="translate(0.5 0.891113)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
